jQuery($ => {
    class SearchToggle {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._trigger = this._element.find('.m-popover-toggle__trigger-input');
        this._content = this._element.find('.m-popover-toggle__content');
        this._backButton = this._content.find('.m-popover-toggle__back-button');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );

        // Add "inert" attribute to the content
        // We only want this if JS is available
        this._content.attr('inert', '');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Utility functions
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      calculatePosition = () => {
        // If content is not visible, don't calculate position
        if (!this._content.is(':visible')) {
          return;
        }

        // If on mobile sizes (< 1025px), remove left style
        if (window.innerWidth < 1025) {
          this._content[0].style.left = '';
          return;
        }

        const contentRect = this._content[0].getBoundingClientRect();

        // Check if content won't overflow the viewport to the right
        const overflowRight = contentRect.right - window.innerWidth;
        if (overflowRight > 0) {
          // Reposition to make it fit the viewport
          this._content[0].style.left = `calc(50% - ${overflowRight}px - var(--container-padding))`;
        }

        // Check if content won't overflow the viewport to the left
        const overflowLeft = contentRect.left;
        if (overflowLeft < 0) {
          // Reposition to make it fit the viewport
          this._content[0].style.left = `calc(50% + ${Math.abs(overflowLeft)}px + var(--container-padding))`;
        }

        // Check if content is within trigger
        const triggerRect = this._trigger[0].getBoundingClientRect();
        // If left of content is more than left of trigger, or right of content is less than right of trigger
        if (contentRect.left > triggerRect.left || contentRect.right < triggerRect.right) {
          // Reset position and reapply rules
          this._content[0].style.left = `50%`;
          return this.calculatePosition();
        }

      }

      handleClickOutside = (e) => {
        console.log('click outside', e);
        const target = $(e.target);
        // Check if target is within this._element
        if (!target.closest(this._element).length) {
          this.handleClose(true);
        };
      }

      handleToggle(e) {
        if (e.target.checked) {
          this.handleOpen(true);
        } else {
          this.handleClose(true);
        }
      }

      handleOpen() {
        // If trigger is still unchecked, check it
        if (!this._trigger.prop('checked')) {
          this._trigger.prop('checked', true);
        }

        this._element.addClass('m-popover-toggle--open');

        // Remove the "inert" attribute from the content
        this._content.removeAttr('inert');

        this.calculatePosition();

        // Is there a back button?
        // If so, let's add a click event to it
        if (this._backButton.length) {
          this._backButton.on('click', () => {
            this.handleClose();
          });
        }

        const parentItem = this._element.closest('.m-header-bottom-nav__item');
        if (parentItem.length) {
          parentItem.addClass('m-header-bottom-nav__item--open');
        }
        const parentNav = this._element.closest('.m-header-bottom-nav');
        if (parentNav.length) {
          parentNav.addClass('m-header-bottom-nav--open');
        }

        setTimeout(() => {
          $('body').on('click', this.handleClickOutside);
        }, 0);
      }

      handleClose() {
        this.unregisterClickOutside();
        this._element.removeClass('m-popover-toggle--open');
        
        // If trigger is still checked, uncheck it
        if (this._trigger.prop('checked')) {
          this._trigger.prop('checked', false);
        }

        const parentItem = this._element.closest('.m-header-bottom-nav__item');
        if (parentItem.length) {
          parentItem.removeClass('m-header-bottom-nav__item--open');
        }
        const parentNav = this._element.closest('.m-header-bottom-nav');
        if (parentNav.length) {
          parentNav.removeClass('m-header-bottom-nav--open');
        }
      }

      unregisterClickOutside() {
        $('body').off('click', this.handleClickOutside);
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._trigger.on('change', (e) => this.handleToggle(e));

        $(window).on('resize', () => {
          this.calculatePosition();
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.search_toggle = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].search_toggle = new SearchToggle(_[i], opt);
        else
          ret = _[i].search_toggle[opt].apply(_[i].search_toggle, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-popover-toggle').search_toggle();
});